import { useTranslations } from 'next-intl';
import {
  CustomStyledLabel,
  RequestServiceContactRadioInput
} from '@cat-ecom/pcc-components';
import { CatHeading, CatFieldset } from 'components/blocks-components';
import { SELECT_TIME_PREFERENCE } from '../constant';

const RequestEquipmentServiceTimeRadioInput = ({ isMobile }) => {
  const t = useTranslations();

  const radioButton = (item) => {
    return (
      <RequestServiceContactRadioInput
        name="preferredDateTime.time"
        value={item.value}
        classname={'mb-md-4 mb-3 d-block'}
        key={item.value}
      >
        <CustomStyledLabel> {t(item.translation)}</CustomStyledLabel>
      </RequestServiceContactRadioInput>
    );
  };

  return (
    <div className="mt-4 pt-2 pt-md-0 mx-n2 mx-md-n0">
      <div className="d-flex px-2">
        <CatHeading variant="label">
          <CustomStyledLabel> {t('RS_SELECT_TIME')}</CustomStyledLabel>
        </CatHeading>
      </div>
      <div className="mt-4">
        <CatFieldset orientation={!isMobile ? 'horizontal' : null}>
          {SELECT_TIME_PREFERENCE.map((item) => radioButton(item))}
        </CatFieldset>
      </div>
    </div>
  );
};

export default RequestEquipmentServiceTimeRadioInput;
